/** Tela cheia de espera (anel girando + robô) enquanto o Auth0 ou a sessão resolvem. */
export const LoadingScreen: React.FC = () => (
  <div role="status" aria-busy="true" className="flex h-screen items-center justify-center bg-canvas">
    <div className="relative h-44 w-44">
      <img src={`${process.env.PUBLIC_URL}/loading.svg`} alt="" className="absolute inset-0 h-full w-full animate-spin" />
      <img src={`${process.env.PUBLIC_URL}/robot.svg`} alt="" className="absolute left-1/4 top-1/4 h-1/2 w-1/2" />
    </div>
  </div>
);
